import { Col, Row } from "antd";
import PropTypes from 'prop-types';
import React from "react";
import profile from "../../../../assets/icons/profile-3.svg";
import Aggregator from "../../../../assets/icons/aggregator_leaf.svg";
import { BlurContainer, DisplayFlex, EllipsisContent, EllipsisDataValueWrapper, EllipsisUnderline, PrimaryIndicator } from "../../../../CommonComponents/commonStyles";
import HyperLinkComponent from "../../../../CSR/CommonComponents/HyperLinkComponent/HyperLinkComponent";
import { ENTITY_OVERVIEW_URL } from "../../../../CSR/utils/geminiUrlMapper";
import { isGeminiUser } from "../../../../utils/sessionUtil";
import { AlignItemsCenter1, ItemData, ItemHeading, PersonnelHeading, InlineDiv } from "../../styles";
import { sortAggrDates, isNewAdvent } from "../../utils";




const showPrimaryContactIndicator = info => {
  if (info.primaryAccountContact) {
    return (
      <PrimaryIndicator className="ml-10 mb-10">Primary</PrimaryIndicator>
    );
  }
  return "";
};


const getCountryName = (countryCode,countryCodeMappingData) => {
  let  selectedCountryData = countryCodeMappingData
    ? countryCodeMappingData.find(data => {
        return data.value === countryCode;
      })
    : "";
  if (selectedCountryData) {
    return selectedCountryData.desc;
  }
};


export default function Advisor({ advisorInfo, countryCodeMappingData }) {

  let { addresses, partyId } = advisorInfo;
  const dataAggregators = sortAggrDates(advisorInfo.dataAggregators);
  return (
    <Col lg={8} md={8} xs={24}>
      <Row>
        <Col lg={2} md={2} xs={2}>
          <img src={profile} alt="primaryProfileIcon" />
        </Col>
        <Col lg={22} md={22} xs={22}>
          <AlignItemsCenter1 className="mb1">
            <PersonnelHeading>
              {advisorInfo.primaryAdvisor ? "Primary Advisor" : "Secondary Advisor"}
            </PersonnelHeading>
            {showPrimaryContactIndicator(advisorInfo)}
          </AlignItemsCenter1>
          {
            isGeminiUser() ?
              <ItemData>
                <HyperLinkComponent to={`${ENTITY_OVERVIEW_URL}?partyId=${partyId}`} text={`${
									advisorInfo.title ? advisorInfo.title + " " : ""
								}${advisorInfo.firstName ? advisorInfo.firstName : null}${
									advisorInfo.middleName ? " "+advisorInfo.middleName : ""
								}${
									advisorInfo.lastName ? " "+advisorInfo.lastName : ""
								}${
									advisorInfo.suffix ? ", "+advisorInfo.suffix : ""
								}`}>
							  </HyperLinkComponent>
							</ItemData> :
              <ItemData className="mt0">{`${
								advisorInfo.title ? advisorInfo.title + " " : ""
								}${advisorInfo.firstName ? advisorInfo.firstName : null}${
									advisorInfo.middleName ? " "+advisorInfo.middleName : ""
								}${
									advisorInfo.lastName ? " "+advisorInfo.lastName : ""
								}${
									advisorInfo.suffix ? ", "+advisorInfo.suffix : ""
								}`}
						  </ItemData>
          }
          
         
          <DisplayFlex className="mt-05">
            <ItemHeading>DOB :</ItemHeading>
            <ItemData className="mt0 ml-05">
              {advisorInfo.dob ? (
                advisorInfo.dateOfBirthStr
              ) : (
                <> &mdash; </>
              )}
            </ItemData>
          </DisplayFlex>
          <DisplayFlex className="mt-05">
            <ItemHeading>Email :</ItemHeading>
            <ItemData className="mt0 ml-05">
              {advisorInfo.email ? <EllipsisDataValueWrapper>
                <EllipsisUnderline>{advisorInfo.email}</EllipsisUnderline>
                <EllipsisContent>                 
                  {advisorInfo.email}
                </EllipsisContent>
              </EllipsisDataValueWrapper> : <> &mdash; </>}
            </ItemData>
          </DisplayFlex>
          <DisplayFlex className="mt-05">
            <ItemHeading>Phone :</ItemHeading>
            <ItemData className="mt0 ml-05">
              {advisorInfo.phone ? advisorInfo.phone : <> &mdash; </>}
            </ItemData>
          </DisplayFlex>
          <DisplayFlex className="mt-05">
            <ItemHeading>Address :</ItemHeading>
            {addresses.length !== 0 ? (
              <div>
                <ItemData className="mt0 ml-05">
                  {addresses[0].address
                    ? `${addresses[0].address}, `
                    : ""}
                </ItemData>
                <ItemData className="mt0 ml-05">
                  {addresses[0].addressLine1
                    ? `${addresses[0].addressLine1}, `
                    : ""}
                </ItemData>
                <ItemData className="mt0 ml-05">
                  {addresses[0].addressLine2
                    ? `${addresses[0].addressLine2}, `
                    : ""}
                </ItemData>
                <ItemData className="mt0 ml-05">
                  {addresses[0].addressLine3
                    ? `${addresses[0].addressLine3}, `
                    : ""}
                </ItemData>
                <ItemData className="mt0 ml-05">
                  {addresses[0].city?`${addresses[0].city}, `:""}
                  {addresses[0].state?`${addresses[0].state}, `: " "}
                  {addresses[0].zipCode?`${addresses[0].zipCode},`:""}
                </ItemData>
                <ItemData className="mt0 ml-05">
                  {getCountryName(addresses[0].country,countryCodeMappingData)}
                </ItemData>
              </div>
            ): <> &nbsp; &mdash; </>}
            </DisplayFlex>
          {dataAggregators.length ?
            (<DisplayFlex className="mt-05">
              <ItemHeading>Data Aggregator :</ItemHeading>
              <ItemData className="mt0 ml-05">
                {dataAggregators.map((agg, cnt) => {
                  if (dataAggregators.length - 1 === cnt) return agg.aggrName;
                  else return agg.aggrName + ', ';
                })}
                   {isNewAdvent(dataAggregators) ? (
                  <InlineDiv>
                    <img src={Aggregator} className="aggregator_iconleaf" alt="aggregator" />
                    <span className="aggregator_newbtn">New</span></InlineDiv>
                ) : <></>}
              </ItemData>
            </DisplayFlex>) : <></>}
          <DisplayFlex className="mt-05">
            <ItemHeading>Delivery Type :</ItemHeading>
            <ItemData className="mt0 ml-05">
              {advisorInfo.deliveryMethod ? (
                advisorInfo.deliveryMethod
              ) : (
                <> &mdash; </>
              )}
            </ItemData>
          </DisplayFlex>
          { isGeminiUser() && 
            <BlurContainer className="gemini-notes-info-container">
              <DisplayFlex className="mt-05">
                <ItemHeading>Web Access: </ItemHeading>
                <ItemData className="mt0 ml-05">
                    {advisorInfo.webAccess ? (
                        advisorInfo.webAccess  
                    ) : (
                        <> &mdash; </>
                    )}
                </ItemData>
              </DisplayFlex>
              <DisplayFlex className="mt-05">
                <ItemHeading> Permission to share: </ItemHeading>
                <ItemData className="mt0 ml-05">
                    {advisorInfo.permissionToShare ? (
                        advisorInfo.permissionToShare  
                    ) : (
                        <> &mdash; </>
                    )}
                </ItemData>
              </DisplayFlex>
            </BlurContainer>
          }
        </Col>
      </Row>
    </Col>
  );
}

Advisor.propTypes = {
  advisorInfo: PropTypes.object,
  countryCodeMappingData: PropTypes.array
}
